/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_SubtitleInputs */



/**
* | output |
* | --- |
* | "Sign in to continue with Wundo." |
*
* @param {Login_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_subtitle = /** @type {((inputs?: Login_SubtitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_SubtitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meld je aan om verder te gaan met Wundo.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour continuer avec Wundo.")
	return /** @type {LocalizedString} */ ("Sign in to continue with Wundo.")
});